<template>
  <CommonTable
    :listArray="values"
    :sort="sort"
    :headers="headers"
    :slots="slots"
    :actions="actions"
    resource="analysis"
    :loading="loading"
    class="table"
  ></CommonTable>
</template>

<script>
import CommonTable from "../../common/tables/CommonTable";
import moment from "moment-timezone";
export default {
  name: "MeterCounts",
  components: {
    CommonTable
  },
  props: {
    project_id: {
      type: String
    },
    meterUnits: {
      type: Array
    }
  },
  data() {
    return {
      actions: [],
      list: {},
      loading: false,
      now: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      project: {},
      values: []
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("analysis.date"),
          align: "left",
          value: "date"
        },
        ...(this.meterUnits || [])
          .map(i =>
            (i._ingestion._tariffs && i._ingestion._tariffs.length
              ? i._ingestion._tariffs
              : [{}]
            ).map(tariff => ({
              text: `${i.name}${tariff.name ? " - " + tariff.name : ""} ${
                i._ingestion.symbol
              }`,
              value: `${i.id}-${tariff.id}`
            }))
          )
          .flat()
      ];
    },
    slots() {
      return (this.meterUnits || []).map(i =>
        (i._ingestion._tariffs && i._ingestion._tariffs.length
          ? i._ingestion._tariffs
          : [{}]
        )
          .map(tariff => ({
            name: `${i.id}-${tariff.id}`,
            type: "text"
          }))
          .flat()
      );
    }
  },
  methods: {
    getRecords() {
      this.records = [];
      this.$set(this, "list", {});
      this.loading = true;
      if (this.meterUnits && this.meterUnits.length) {
        this.$store.dispatch(
          "projectMeteringStore/meterUnitRecordStore/getList",
          {
            params: {
              project_id: this.project_id,
              interval: "month",
              limit: -1,
              includeReplaced: true,
              rawRecord: true,
              filters: {
                meter_unit: this.meterUnits.map(i => i.id).join(";"),
                time: {
                  from: moment(this.now)
                    .subtract(3, "year")
                    .format("YYYY-MM-DD"),
                  to: this.now
                }
              }
            },
            onSuccess: res => {
              this.setList(res.list);
              this.loading = false;
            }
          }
        );
      } else {
        this.loading = false;
      }
    },
    setList(list) {
      let correctDiffs = [0, 1, 2, 3, 6, 9, 12, 24, 36];
      let vm = this;
      correctDiffs = correctDiffs.map(i => {
        return moment(this.now)
          .local()
          .subtract(i, "month")
          .format("YYYY-MM-DD");
      });
      // set n.I.
      correctDiffs.forEach(i => {
        this.meterUnits.map(unit =>
          (unit._ingestion._tariffs && unit._ingestion._tariffs.length
            ? unit._ingestion._tariffs
            : [{}]
          ).map(tariff => {
            let date = vm.$dateTime(i, "short");
            vm.list[date] = {
              date,
              [`${unit.id}-${tariff.id}`]: "n.I.",
              ...vm.list[date],
              time: i
            };
          })
        );
      });
      list.forEach(item => {
        let itemDate = moment
          .tz(item.time, this.project.timezone)
          .format("YYYY-MM-DD");
        let id = `${item._meter_unit && item._meter_unit.id}-${item._tariff &&
          item._tariff.id}`;
        if (correctDiffs.find(i => i === itemDate)) {
          let date = vm.$dateTime(itemDate, "short", "", "UTC");
          this.list[date] = {
            ...this.list[date],
            date,
            time: item.time,
            [id]: this.$number(item.value),
            [`${id}-value`]: +item.value
          };
        }
      });
      this.values = Object.values(this.list).sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
    },
    sort: function(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] === "date") {
          if (!isDesc[0]) {
            return new Date(b.time) - new Date(a.time);
          } else {
            return new Date(a.time) - new Date(b.time);
          }
        } else {
          if (!isDesc[0]) {
            return (b[`${index}-value`] || 0) - (a[`${index}-value`] || 0);
          } else {
            return (a[`${index}-value`] || 0) - (b[`${index}-value`] || 0);
          }
        }
      });
      return items;
    }
  },

  watch: {
    meterUnits: {
      handler: function() {
        this.getRecords();
      },
      deep: true
    }
  },
  mounted() {
    this.getRecords();
    this.$store.dispatch("projectStore/get", {
      id: this.project_id,
      onSuccess: project => {
        this.project = project;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.table {
  height: auto;
  min-height: 400px;
}
</style>
